import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { DATE_TIME_FORMAT } from '@models/common.models';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-date-column',
  standalone: true,
  imports: [],
  providers: [DatePipe],
  templateUrl: './date-column.component.html',
  styleUrl: './date-column.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateColumnComponent implements AgRendererComponent {
  readonly #datePipe: DatePipe = inject(DatePipe);

  readonly #date = signal<string | number | null>(null);

  public readonly dateFormatted = computed(() => {
    if (this.#date() !== null) {
      return this.#datePipe.transform(this.#date(), DATE_TIME_FORMAT.DATE_TIME_FULL_SLASH) as string;
    } else {
      return '';
    }
  });

  agInit(params: ICellRendererParams): void {
    this.#date.set(params.value);
  }

  refresh(params: ICellRendererParams): boolean {
    this.agInit(params);
    return true;
  }
}
